import { render, staticRenderFns } from "./Recipe.vue?vue&type=template&id=e004052c&scoped=true&"
import script from "./Recipe.vue?vue&type=script&lang=ts&"
export * from "./Recipe.vue?vue&type=script&lang=ts&"
import style0 from "./Recipe.vue?vue&type=style&index=0&id=e004052c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e004052c",
  null
  
)

export default component.exports